import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { PageHeader } from "@/components/common";
import { Button } from "@/components/ui/button";
import { PhotoReceiveDialog } from "@/components/PhotoReceiveDialog";
import { ScanSmiley, CheckCircle } from "@phosphor-icons/react";
import { fmtDateTime } from "@/components/common";

export default function StockIntake() {
  const [open, setOpen] = useState(false);
  const [warehouses, setWarehouses] = useState([]);
  const [done, setDone] = useState([]);
  useEffect(() => { api.get("/warehouses").then((r) => setWarehouses(r.data || [])).catch(() => {}); }, []);
  return (
    <div className="space-y-6">
      <PageHeader subtitle="Warehouse" title="Stock Intake" actions={<Button className="rounded-sm" onClick={() => setOpen(true)} data-testid="intake-open-btn"><ScanSmiley size={16} className="mr-2" /> Receive from Photos</Button>} />
      <div className="hp-card p-6 space-y-3" data-testid="intake-card">
        <p className="text-sm">For every product received, take <strong>two photos</strong>: the <strong>front of the pack</strong> (product name, strength and how many packs) and the <strong>side with LOT and EXP</strong>. The app reads item, quantity, batch and expiry from the photos and adds them to the stock list. The photos are kept with the batch for audit.</p>
        <ol className="text-sm text-muted-foreground list-decimal pl-5 space-y-1">
          <li>Tap <em>Receive from Photos</em>.</li>
          <li>Photograph the front (all packs of that item in one shot), then the batch/expiry side.</li>
          <li>Add more items if needed, then save.</li>
        </ol>
        <Button variant="outline" className="rounded-sm" onClick={() => setOpen(true)} data-testid="intake-open-btn-2"><ScanSmiley size={16} className="mr-2" /> Start</Button>
      </div>
      {done.length > 0 && (
        <div className="hp-card p-4 space-y-1 text-sm" data-testid="intake-done">
          <p className="font-semibold flex items-center gap-1.5"><CheckCircle size={16} weight="fill" className="text-emerald-600" /> Received this session</p>
          {done.map((d, i) => <p key={i} className="text-muted-foreground">{fmtDateTime(d.at)} — goods receipt saved</p>)}
        </div>
      )}
      <PhotoReceiveDialog open={open} onClose={() => setOpen(false)} warehouses={warehouses} photosOnly onSaved={() => setDone((x) => [{ at: new Date().toISOString() }, ...x])} />
    </div>
  );
}
